import React, { useEffect, useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../services/api';
import './ForgotPassword.css';

const ForgotPassword: React.FC = () => {
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [operators, setOperators] = useState<Array<{ id: number; name: string }>>([]);
  const [operatorId, setOperatorId] = useState<number | ''>('');
  const [loadingOperators, setLoadingOperators] = useState(false);
  const [operatorsError, setOperatorsError] = useState('');
  const [isAdminUser, setIsAdminUser] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    setLoading(true);

    try {
      if (!isAdminUser && !operatorId) {
        setError('Seleziona un operatore.');
        setLoading(false);
        return;
      }
      const response = await authService.forgotPassword(username, operatorId ? Number(operatorId) : 0);
      setSuccess(response.message);
    } catch (err: any) {
      setError(err.response?.data?.message || 'Errore durante la richiesta di reset password');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const value = username.trim();
    if (!value || value.length < 3) {
      setOperators([]);
      setOperatorId('');
      setOperatorsError('');
      setIsAdminUser(false);
      return;
    }

    let isActive = true;
    const timer = setTimeout(() => {
      setLoadingOperators(true);
      setOperatorsError('');
      authService
        .forgotPasswordOperators(value)
        .then((data) => {
          if (!isActive) return;
          setOperators(data.operators || []);
          setOperatorId('');
          setIsAdminUser(!!data.is_admin);
          if (!data.operators || data.operators.length === 0) {
            setOperatorsError('Nessun operatore trovato per questo utente.');
          }
        })
        .catch((err) => {
          if (!isActive) return;
          setOperators([]);
          setOperatorId('');
          setIsAdminUser(false);
          setOperatorsError(err.response?.data?.message || 'Utente non trovato.');
        })
        .finally(() => {
          if (!isActive) return;
          setLoadingOperators(false);
        });
    }, 500);

    return () => {
      isActive = false;
      clearTimeout(timer);
    };
  }, [username]);

  return (
    <div className="forgot-page">
      <div className="forgot-wrapper">
        <div className="forgot-card">
        <Link to="/login" className="forgot-back">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 3.3335L5.33333 8.00016L10 12.6668" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M6 8H12" stroke="#4A5565" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Torna al login
        </Link>

        <div className="forgot-header">
          <h1>Password dimenticata?</h1>
          <p>Inserisci i tuoi dati e ti invieremo le istruzioni per reimpostarla</p>
        </div>

        {error && <Alert variant="danger" className="forgot-alert">{error}</Alert>}
        {success && <Alert variant="success" className="forgot-alert">{success}</Alert>}

        <Form onSubmit={handleSubmit} className="forgot-form">
          <div className="forgot-field">
            <Form.Label>Nome utente</Form.Label>
            <Form.Control
              type="text"
              placeholder="Scrivi qui il tuo nome utente"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              className="forgot-input"
            />
          </div>

          <div className="forgot-field">
            {!isAdminUser && (
              <>
                <Form.Label>Operatore</Form.Label>
                <div className="forgot-select-wrap">
                  <Form.Select
                    value={operatorId}
                    onChange={(e) => setOperatorId(e.target.value ? Number(e.target.value) : '')}
                    className="forgot-input"
                    disabled={loadingOperators || operators.length === 0}
                  >
                    <option value="">Seleziona operatore</option>
                    {operators.map((op) => (
                      <option key={op.id} value={op.id}>{op.name}</option>
                    ))}
                  </Form.Select>
                  <span className="forgot-select-icon">▾</span>
                </div>
                {operatorsError && <div className="forgot-help">{operatorsError}</div>}
              </>
            )}
          </div>

          <Button
            type="submit"
            className="forgot-submit"
            disabled={loading || loadingOperators || (!isAdminUser && !operatorId)}
          >
            {loading ? 'Invio in corso...' : 'Invia link di recupero'}
          </Button>
        </Form>
        
        </div>
        <p className="forgot-footer">© 2021 All rights reserved Estetica Cruciani</p>
      </div>
    </div>
    
  );
};

export default ForgotPassword;
